import { IIdObject } from '@common/interfaces/id-object.interface';
import { IPaymentSource } from '../registration-generated-api';

export type IPaymentSourceDto = IPaymentSource & IIdObject;

export const createPaymentSourceDto = (item: IPaymentSource): IPaymentSourceDto => {
    return {
        ...item,
        id: item.id || '',
    };
};
